export default __webpack_public_path__ + "vk-social-network-logo.png";